/**
 * @file 余额
 * @author izzieyspu
 */

import React, { useMemo } from 'react';
import { Flex, HelpTips, Text } from '@tencent/odc';
import { Loading } from '@tencent/spaui';
import { scientific } from '@/utils/formater';
import FinanceAlertTip from '@/business-components/finance-alert-tip';
import HomeItem from '../home-item';
import store from '../../store';
import _ from 'lodash';

const CostBalance: React.FC = () => {
  const balance = useMemo(() => {
    return (store.todayCostData as any)?.total_balance;
  }, [store.todayCostData]);

  return <HomeItem
    className="mini"
    header={<>
      <div className="title">财务概览</div>
      <div className="right"><FinanceAlertTip onlyLabel /></div>
    </>}
  >
    <Flex justifyContent="between" className="tw-h-[24px]">
      <Text type="secondary" suffix={<HelpTips tips="数据每1h更新，可能与报表模块存在一定差异。" />}>总余额(元)</Text>
      {_.isNil(balance) ? <Loading display="inline-block" /> : <Text type="strong" size="large">{scientific(balance, 2)}</Text>}
    </Flex>
  </HomeItem>;
};

export default CostBalance;
